import { common } from './common.icons';

export const IconInfoGraphic = ({ className = '', style = {}, ...rest }: any) => {
  return (
    <svg
      viewBox="0 0 96 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon-infographic ${common.classes} ${className}`}
      {...rest}
      style={{ ...common.styles, ...style }}
    >
      <path
        d="M52.0832 23.5255L64.4832 9.4255C66.3832 7.3255 66.2832 4.1255 64.1832 2.1255C62.0832 0.0255027 58.6832 0.125501 56.6832 2.2255L43.2832 15.8255L52.0832 23.5255Z"
        fill="currentColor"
      />
      <path
        d="M93.6836 2.02589C91.5836 -0.0741076 88.1836 0.0258927 86.1836 2.12589L54.0836 34.9259L38.7836 20.0259C36.8836 18.1259 33.7836 17.9259 31.5836 19.7259C29.2836 21.6259 28.9836 25.0259 30.8836 27.2259L31.3836 27.8259L24.5836 34.9259L9.38361 20.0259C7.48361 18.1259 4.38361 17.9259 2.18361 19.7259C-0.116392 21.6259 -0.416392 25.0259 1.48361 27.2259L19.7836 49.0259C19.9836 49.2259 20.1836 49.5259 20.4836 49.7259C23.1836 52.0259 27.1836 51.8259 29.5836 49.1259L29.6836 49.0259L39.6836 37.6259L49.2836 49.0259C49.4836 49.2259 49.6836 49.5259 49.9836 49.7259C52.6836 52.0259 56.6836 51.8259 59.0836 49.1259L59.1836 49.0259L93.9836 9.42589C95.7836 7.32589 95.6836 4.02589 93.6836 2.02589Z"
        fill="currentColor"
      />
    </svg>
  );
};
